// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1271":"54821d6f","9456":"dcb993a6"}[chunkId] + ".chunk.css";
};